import { apiBusSchedBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

export class DataUpdateAPI {
    constructor() {
        this.baseUrl = new URL("bussched/dataupdates/", apiBusSchedBaseURL);
    }

    list(networkEdition) {
        return API.authenticatedRequest({
            url: new URL(`${networkEdition}`, this.baseUrl),
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/bussched/DataUpdateAPI.js